<button [attr.id]="buttonId()"
        tdWbButton
        tdWbButtonSize="xs"
        [tdWbButtonType]="buttonType()"
        (click)="onClick()">
  <ng-content/>
</button>
